import React from 'react';
import { Link } from 'react-router-dom';

export const AdminVendedoresHeader = ({ onOpenAddModal, onLogout }) => {
  return (
    <div className="bg-white shadow-sm" data-testid="admin-vendedores-header">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/admin" className="text-gray-600 hover:text-gray-900" data-testid="admin-vendedores-back-admin-link">
            ← Admin
          </Link>
          <h1 className="text-xl font-bold text-gray-900" data-testid="admin-vendedores-page-title">Gestão de Vendedores</h1>
        </div>
        <div className="flex items-center gap-2" data-testid="admin-vendedores-header-actions">
          <button
            onClick={onOpenAddModal}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            data-testid="admin-vendedores-open-add-modal-button"
          >
            + Novo Vendedor
          </button>
          <button
            onClick={onLogout}
            className="px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition"
            data-testid="admin-vendedores-logout-button"
          >
            🚪 Sair
          </button>
        </div>
      </div>
    </div>
  );
};
